import api from './http';

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');
export const getConventionsPendingSignature = () => api.get('/dashboard/conventions-pending-signature');
export const getMissionsByTerritory = () => api.get('/dashboard/missions-by-territory');
export const getRecentActivity = (limit = 10) => api.get(`/dashboard/recent-activity?limit=${limit}`);

// Territory Analytics
export const getTerritoryAnalytics = (params = {}) => {
  const q = new URLSearchParams();
  if (params.period) q.append('period', params.period);
  if (params.territoire) q.append('territoire', params.territoire);
  if (params.date_start) q.append('date_start', params.date_start);
  if (params.date_end) q.append('date_end', params.date_end);
  return api.get(`/analytics/territories?${q.toString()}`);
};

// Dashboard Preferences
export const getDashboardPrefs = () => api.get('/preferences/dashboard');
export const saveDashboardPrefs = (widgets) => api.put('/preferences/dashboard', { widgets });

// Dashboard layout
export const getDashboardLayout = () => api.get('/dashboard-layout');
export const saveDashboardLayout = (layout) => api.put('/dashboard-layout', { layout });
export const getAvailableWidgets = () => api.get('/dashboard-layout/widgets');
